import React from 'react';

export type TOCItem = { id: string; label: string };

const StickyTOC: React.FC<{ items: TOCItem[] }> = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <nav aria-label="On-page navigation" className="hidden lg:block sticky top-24 self-start w-64 mr-6">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">On this page</p>
        <ul className="mt-2 space-y-2">
          {items.map((it) => (
            <li key={it.id}>
              <a href={`#${it.id}`} className="text-sm text-gray-700 hover:text-indigo-700">
                {it.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default StickyTOC;
